<div
    class="content-expansion-container"
    #contentExpansionContainer
    data-cy="content-expansion-container">
    <article class="expandable-content">
        <section class="expandable-section" [id]="uniqueContentId" data-cy="expandable-content">
            <div class="outer-toggle-wrapper" [@collapse-expand]="contentExpansionState()">
                <div class="inner-toggle-wrapper">
                    <ng-content select="expandable-content"></ng-content>
                </div>
            </div>
            <div class="button-container">
                <button
                    class="toggle-content-switch"
                    data-cy="toggle-content-switch"
                    siriusButton
                    type="button"
                    [buttonType]="'secondary'"
                    [buttonText]="
                        isCollapsed()
                            ? ('commerce.showMoreInfo' | translate)
                            : ('commerce.showLessInfo' | translate)
                    "
                    [attr.aria-controls]="uniqueContentId"
                    [attr.aria-expanded]="isCollapsed()"
                    (click)="toggleContent()">
                    @if (isCollapsed()) {
                        <sirius-icon name="caret_down"></sirius-icon>
                    } @else {
                        <sirius-icon name="caret_up"></sirius-icon>
                    }
                </button>
            </div>
        </section>
    </article>
</div>
